import React, { useEffect, useState } from 'react';
import { useProject } from '../../hooks/useProject';
import { AutoCompleteSelectUI, FormLabelUI } from '../Interface';
import projectService from '../../service/project.service';
import { ProjectPage } from '../Project/ProjectPage';
import masterDataService from '../../service/masterData.service';
import { generateAutocompleteItems } from '../../utils/helper';

export const ProjectInfoPanelPage = () => {
  const projectState = useProject();
  const [projects, setProjects] = useState([]);
  const [filterFormState, setFilterFormState] = useState({
    projectId: '',
  });

  useEffect(() => {
    getProjects();
  }, []);

  useEffect(() => {
    if (filterFormState.projectId) {
      projectService.getProjectById(filterFormState.projectId).then((data) => {
        projectState.setSelectedValues(data);
      });
    }
  }, [filterFormState]);

  const getProjects = () => {
    masterDataService
      .projectToForm()
      .then((data) => {
        const filteredProject = data.filter((project) => project.active);

        const acOptions = generateAutocompleteItems(filteredProject, 'projectName', 'projectId');

        setProjects(acOptions);
      })
      .finally(() => {});
  };

  return (
    <div className="bg-gray-100  px-1 md:px-5">
      <div className="pb-2">
        <div className="w-full md:w-[250px] pt-2">
          <AutoCompleteSelectUI
            label={<FormLabelUI text="Projekt választó" />}
            selectedValue={filterFormState.projectId}
            onChange={(_e, newVal, reason) => {
              setFilterFormState((prevState) => ({
                ...prevState,
                projectId: newVal?.value ?? null,
              }));
            }}
            dataset={projects}
          />
        </div>
      </div>
      <div className="bg-white rounded">
        <ProjectPage projectState={projectState} infoPanel={true} />
      </div>
    </div>
  );
};
